export default {
    name: "Landing"
};